export const commContent = {
    es: {
        eyebrow: 'EL PROCESO',
        title: '¿Cómo funciona?',
        steps: [
            { title: 'Haz tu pedido', body: 'Haz tu pedido eligiendo la suscripción que mejor se adapte a ti.' },
            { title: 'Recibe tu acceso', body: 'Tras el pago, recibirás por email en menos de 10 minutos tus credenciales y una guía de instalación.' },
            { title: 'Disfruta de tu IPTV', body: '¡Disfruta ya de todos los canales, películas y series!' },
        ],
        ctaTitle: 'Elige el proveedor IPTV n.º 1 de Europa',
        ctaButton: 'Comprar ahora',
    },
};
